'use strict';

var _ = require('lodash');
var GlobalNotifPanelDataService = function GlobalNotifPanelDataService($q, dataRetrieverService, constants, liteDataService, featureToggleService, restangular) {
  function getData() {
    return dataRetrieverService.getDataRetriever(constants.APPLICATION_SCREEN_GLOBAL_NOTIFICATION, constants.GLOBAL_NOTIFICATION_MODE).retrieveSimpleData(constants.GLOBAL_NOTIFICATION_MODE, undefined);
  }
  function getTotalAlertsNumber() {
    return getData().then(function (result) {
      if (featureToggleService.isEnabled('NPS_HOST_SHARE')) {
        return result.domain.length;
      } else {
        return 0;
      }
    });
  }
  return {
    getData: getData,
    getTotalAlertsNumber: getTotalAlertsNumber
  };
};
GlobalNotifPanelDataService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'LiteDataService', 'FeatureToggleService', 'GlobalNotifConstants', 'Restangular'];
module.exports = GlobalNotifPanelDataService;